import { displayRushMax, maxFerocity } from '../../utils/arena/battlemage';
import { RushGauge, FerocityGauge } from '../play/BattlemageGauges';

// The Battlemage's stacks and banked Ferocity under the constellation: the
// same gauges the standing shows, in the slot the Oracle's vial uses, so
// the foundation star above stays clear.
export default function BattlemageStanding({ skillState, battlemage }) {
  const cap = displayRushMax(skillState);
  const ferocityMax = maxFerocity(skillState);
  const rush = battlemage?.rush || 0;
  return (
    <div className="vh-potency-slot relative" style={{ height: '3cqw' }} data-testid="battlemage-standing">
      <div className="absolute left-1/2 -translate-x-1/2 flex items-center" style={{ bottom: '-1.75cqw', gap: '3cqw' }}>
        <RushGauge rush={cap == null ? rush : Math.min(rush, cap)} max={cap} size={1.35} />
        {ferocityMax > 0 ? <FerocityGauge value={Math.min(battlemage?.ferocity || 0, ferocityMax)} max={ferocityMax} width={30} size={1.35} /> : null}
      </div>
    </div>
  );
}
